import potentialCalamityService from "../api/server/potentialCalamityService";
export const POTENTIAL_CALAMITY_NAMESPACE = "potentialCalamityModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/potentialCalamityService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(potentialCalamityService)
};

const state = {
  loading: true,
  potentialCalamities: [],
  selectedPotential: {},
  filterOnTimeZones: [],
  filterOnClients: [],
  selectedPotentialPackages: []
};
const actions = {
  async CREATE(context, data) {
    var api = await services.api;
    return api.create(data).then(function(value) {
      context.commit("RESET");
    });
  },
  SELECT_ALL(context, data) {
    return context.commit("SET_ALL_SELECTED", data);
  },
  CLEAR_ALL(context, data) {
    return context.commit("CLEAR_SELECTED", data);
  },
  async LOAD_POTENTIAL(context) {
    var api = await services.api;
    context.commit("RESET_POTENTIAL");
    state.loading = true;
    return api.loadPotential().then(function(value) {
      context.commit("SET_POTENTIAL", value);
    });
  },
  FILTER_BY_CLIENT(context, value) {
    context.commit("SET_CLIENT_FILTER", value);
  },

  FILTER_BY_TIMEZONE(context, value) {
    context.commit("SET_TIMEZONE_FILTER", value);
  },
  SELECT_POTENTIAL(context, value) {
    context.commit("SET_SELECTED_POTENTIAL", value);
  },
  async LOAD_POTENTIAL_PACKAGES(context, value) {
    var api = await services.api;
    state.loading = true;
    return api.loadPotentialPackages(value).then(function(value) {
      context.commit("SET_POTENTIAL_PACKAGES", value);
    });
  }
};

const mutations = {
  RESET_POTENTIAL(storeState) {
    storeState.potentialCalamities = [];
  },
  SET_POTENTIAL(storeState, data) {
    storeState.potentialCalamities = data;
    storeState.loading = false;
  },
  SET_TIMEZONE_FILTER(storeState, data) {
    storeState.filterOnTimeZones = data;
  },
  SET_CLIENT_FILTER(storeState, data) {
    storeState.filterOnClients = data;
  },
  SET_SELECTED_POTENTIAL(storeState, data) {
    storeState.selectedPotential = storeState.potentialCalamities.find(
      x => x.HashKey === data.id
    );
    storeState.loading = false;
  },
  SET_POTENTIAL_PACKAGES(storeState, data) {
    data.forEach(function(item) {
      item.selected = false;
    });
    storeState.selectedPotentialPackages = data;
    storeState.loading = false;
  },
  SET_ALL_SELECTED(storeState, data) {
    if (data == null) {
      storeState.selectedPotentialPackages.forEach(function(item) {
        item.selected = true;
      });
    } else {
      storeState.selectedPotentialPackages
        .filter(x => x.TransitState === data)
        .forEach(function(item) {
          item.selected = true;
        });
    }
  },
  CLEAR_SELECTED(storeState, data) {
    if (data == null) {
      storeState.selectedPotentialPackages.forEach(function(item) {
        item.selected = false;
      });
    } else {
      storeState.selectedPotentialPackages
        .filter(x => x.TransitState === data)
        .forEach(function(item) {
          item.selected = false;
        });
    }
  },
  RESET(storeState, data) {
    storeState.loading = false;
    storeState.potentialCalamities = [];
    storeState.selectedPotential = {};
    storeState.selectedPotentialPackages = [];
  }
};

const getters = {
  loading: storeState => storeState.loading,
  potentialCalamities: storeState => storeState.potentialCalamities,
  filteredList: storeState => {
    let filtered = storeState.potentialCalamities;

    if (state.filterOnClients && storeState.filterOnClients.length > 0) {
      filtered = filtered.filter(x =>
        storeState.filterOnClients.includes(x.Client)
      );
    }
    if (
      storeState.filterOnTimeZones &&
      storeState.filterOnTimeZones.length > 0
    ) {
      filtered = filtered.filter(x =>
        storeState.filterOnTimeZones.includes(x.TimeZone)
      );
    }

    return filtered;
  },
  selectedPotentialPackages: storeState => storeState.selectedPotentialPackages,
  selectedPotential: storeState => storeState.selectedPotential
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
